import { useState } from "react";
import { usePanelist } from "../../api";
import { DeactivateAccountOptions } from "../../api/fetchers";
import { ErrorState } from "./AsyncState";
import { Modal } from "./Modal";

interface DeactivateModalProps {
  error?: Error | null;
  isPending?: boolean;
  onClose: () => void;
  onConfirm: (options: DeactivateAccountOptions) => void;
  open: boolean;
}

export function DeactivateModal({
  error,
  isPending = false,
  onClose,
  onConfirm,
  open,
  // panelist,
}: DeactivateModalProps) {
  const { data: panelist } = usePanelist();
  const [allAcounts, setAllAccounts] = useState(false);
  const pointsMessage =
    panelist?.points && panelist.points > 0
      ? `You currently have ${panelist.points} pts (≈ ${panelist.pointsGbp}). These cannot be redeemed after your account is deactivated and will be permanently lost.`
      : "Any remaining points balance cannot be redeemed after your account is deactivated and will be permanently lost.";

  return (
    <Modal onClose={onClose} open={open}>
      <div aria-modal="true" className="modal" role="dialog">
        <div className="modal-header">
          <div className="modal-title title-md">Deactivate your account?</div>
        </div>
        <div className="modal-body">
          <div className="modal-body-text">
            We&apos;re sorry to see you go. Before you confirm, please read the
            following carefully.
          </div>

          <div className="modal-warning">
            <strong>Your data will be removed</strong>
            All your personal data will be permanently removed from our systems
            in line with GDPR. This cannot be undone.
          </div>

          <div className="modal-warning" style={{ marginTop: -8 }}>
            <strong>Your points will be forfeited</strong>
            <span>{pointsMessage}</span>
          </div>

          {/* <div className="modal-body-text">
            <input
              id="all-accounts"
              type="checkbox"
              checked={allAcounts}
              onChange={(e) => setAllAccounts(e.target.checked)}
            />
            <label htmlFor="all-accounts">
              Remove all Flex Panel accounts associated with this email{" "}
              <InfoBadge>
                You may be signed up with other panels who use Flex Panels.
                Ticking this box will remove any of those accounts too.
              </InfoBadge>
            </label>
          </div> */}

          {Boolean(error) && (
            <ErrorState error={error} title="Could not deactivate account" />
          )}
        </div>

        <div className="modal-footer">
          <button
            className="btn btn-outline btn-full"
            disabled={isPending}
            onClick={onClose}
            type="button"
          >
            Cancel
          </button>
          <button
            className="btn btn-full btn-danger"
            disabled={isPending}
            onClick={() =>
              onConfirm({
                removeAllAccounts: !!allAcounts,
              })
            }
            // style={{ background: "var(--red)", color: "#fff" }}
            type="button"
          >
            {isPending ? "Deactivating..." : "Deactivate account"}
          </button>
        </div>
      </div>
    </Modal>
  );
}
